import { render, staticRenderFns } from "./ApplicantNotes.vue?vue&type=template&id=150ce287&scoped=true"
import script from "./ApplicantNotes.vue?vue&type=script&lang=js"
export * from "./ApplicantNotes.vue?vue&type=script&lang=js"
import style0 from "./ApplicantNotes.vue?vue&type=style&index=0&id=150ce287&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "150ce287",
  null
  
)

export default component.exports